'use client'

import { useEffect, useState } from 'react'

import { tw } from '@/lib/utils'

export const ScrollToExplore = ({ label }: { label: string }) => {
  const [opacity, setOpacity] = useState(1)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      const maxScroll = window.innerHeight
      const newOpacity = 1 - (scrollY * 0.8) / maxScroll
      setOpacity(Math.max(0.2, Math.min(1, newOpacity)))
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleClick = () => {
    const el = document.getElementById('explore')
    if (el) el.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div style={{ opacity }}>
      <div
        onClick={handleClick}
        className={tw(
          'hidden cursor-pointer no-underline',
          'lg:absolute lg:bottom-[43px] lg:left-[50px] lg:flex lg:flex-row lg:items-center lg:gap-[16px]',
          'desktop-xl:bottom-[77px] desktop-xl:left-[96px] desktop-xl:gap-[19.667px]'
        )}
      >
        <svg
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="desktop-xl:h-[59px] desktop-xl:w-[59px] h-[48px] w-[48px]"
          aria-label={label}
        >
          <path
            d="M33.4287 0.732422C15.4795 0.732422 0.928711 15.2832 0.928711 33.2324V43.2324C0.928711 46.8223 3.83886 49.7324 7.42871 49.7324H33.4287C42.5414 49.7324 49.9287 42.3451 49.9287 33.2324V7.23242C49.9287 3.64257 47.0186 0.732422 43.4287 0.732422H33.4287Z"
            stroke="white"
            strokeOpacity="0.2"
          />
          <path
            d="M0.925781 40.0223L0.925781 34.2932C0.925781 13.739 15.7888 0.744141 35.7002 0.744141L43.2745 0.744567"
            stroke="white"
          />
          <path d="M25.4287 31.8164L25.4287 18.4433" stroke="white" strokeWidth="1.25373" strokeLinejoin="round" />
          <path d="M18.7734 25.1309L25.46 31.8174L32.1466 25.1309" stroke="white" strokeWidth="1.25373" />
        </svg>
        <span className="text-left text-[16px] leading-[140%] font-normal tracking-[-0.48px] text-white desktop-xl:text-[19.667px] desktop-xl:tracking-[-0.59px]">
          {label}
        </span>
      </div>
    </div>
  )
}
